exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header {\n  color: #333;\n  z-index: 100;\n}\n.header-toolbar {\n  padding: 7px 15px;\n  position: fixed;\n  height: 70px;\n  width: 100%;\n  text-align: center;\n}\n.header-logo {\n  margin-left: -30px;\n  margin-top: 0px;\n  height: 130px;\n  width: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?paths=gui/css!./ui/c/header/style.styl
// module id = 759
// module chunks = 0